import { CaretLeft } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { StyledBackButton } from './BackButton.styled';

interface IBackButtonProps {
  onClick: () => void;
  destination?: string;
  pwId?: string;
  className?: string;
}

const BackButton = ({
  onClick,
  destination,
  pwId,
  className,
}: IBackButtonProps) => {
  const { t } = useTranslation();

  return (
    <StyledBackButton
      secondary
      label={destination ? `${t('Back')}: ${destination}` : t('Back')}
      icon={<CaretLeft size={16} weight="bold" />}
      pwId={pwId}
      className={className}
      onClick={onClick}
    />
  );
};

export default BackButton;
